import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Header() {

  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userId, setUserId] = useState('');

  useEffect(() => {
    const loggedIn = sessionStorage.getItem('loggedIn') === 'true';
    const storedId = sessionStorage.getItem('userId');
    setIsLoggedIn(loggedIn);
    setUserId(loggedIn && storedId ? storedId : '');
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem('loggedIn');
    sessionStorage.removeItem('userId');
    setIsLoggedIn(false);
    setUserId('');
    navigate('/');
  };


  return (
    <div>
        <header>
            <div id='nav' className='nav-box'>
                <div className='text-box'>
                  <Link to='/'>
                    <a className='home'>마리엘 콘텐츠 기록소</a>
                  </Link>
                  <Link to='/post/new'>
                      <a className='nav-text'>글 쓰기</a>
                    </Link>
                    {isLoggedIn && <span>{userId}님</span>}
                    {isLoggedIn ? (<button onClick={handleLogout}>로그아웃</button>) : 
                    (
                <Link to="/login">
                <button>로그인</button>
                </Link>
          )}

                </div>
            </div>
        </header>
    </div>
  )
}

export default Header;